import React, {Component} from "react";
import {BrowserRouter as Router, Switch} from "react-router-dom";
import {authProtectedRoutes, publicRoutes} from "./routes/";
import AppRoute from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";
import "./assets/scss/theme.scss";
import "./assets/css/filejet.css";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (<React.Fragment>
      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (<AppRoute
            path={route.path}
            layout={NonAuthLayout}
            component={route.component}
            key={idx}
            isAuthProtected={false}
          />))}

          {authProtectedRoutes.map((route, idx) => (<AppRoute
            path={route.path}
            layout={VerticalLayout}
            component={route.component}
            key={idx}
            isAuthProtected={true}
            exact
          />))}
        </Switch>
      </Router>
    </React.Fragment>);
  }
}

export default App;
